import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import {  useTheme } from '@material-ui/core';

import AfitdTypography from './AfitdTypography';
import AfitdLink from './AfitdLink';

// import _set from 'lodash/set';

// const useStyles = (params = {}) => {
//     return makeStyles(theme => ({
//         root: {}
//     }));
// };

const AfitdTourStepEndContent = props => {
    const { isHidden, title, message, doneLabel = 'Okay', doneOnClick, children } = props;

    // const theme = useTheme();
    // const classes = useStyles(theme);

    return isHidden ? null : (
        <div>
            {title && (
                <AfitdTypography variant="body1" clsLightBold style={{ marginBottom: 20 }}>
                    {title}
                </AfitdTypography>
            )}
            <AfitdTypography variant="body1">{message || children}</AfitdTypography>
            <div style={{ marginTop: 20, fontSize: 16 }}>
                <AfitdLink color="secondary" label={doneLabel} onClick={doneOnClick} />
            </div>
        </div>
    );
};

export default AfitdTourStepEndContent;
